var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 16.933 16.933",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.964 1.934v5.117c0 1.976-2.51 2.008-2.51 0v-.655c0-.83-1.105-1.133-1.578-.46C2.74 7.413 2.037 8.9 2.037 9.986a6.443 6.443 0 1 0 12.886 0c0-3.094-1.355-6.3-3.42-8.34-1.93-1.93-3.539-1.04-3.539.287z",
    fill: "#ef6356",
    "data-original": "#ef6356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.466 10.364v2.132c0 .823 1.046.837 1.046 0v-.537c0-.345.46-.472.658-.192.474.616.766 1.221.766 1.952a2.685 2.685 0 1 1-5.37 0c0-1.289.565-2.625 1.426-3.475.804-.804 1.474-.433 1.474.12z",
    fill: "#ffc861",
    "data-original": "#ffc861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.055 1.995.214 1.259c.095.556-.454 1.018-1.018 1.018s-1.103-.46-1.019-1.018l.192-1.259c.18-1.019 1.453-1.019 1.631 0z",
    fill: "#ef6356",
    "data-original": "#ef6356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.595 8.903a.53.53 0 0 0-.513.595s.158 1.659-.608 3.036c-.803 1.442-1.857 2.103-1.857 2.103a.532.532 0 0 0 .065.942 6.443 6.443 0 0 0 3.24-5.592c0-.336-.016-.671-.047-1.009a.54.54 0 0 0-.28-.075z",
    fill: "#d85750",
    "data-original": "#d85750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.545 12.704a.53.53 0 0 0-.495.654s.171.881-.32 1.5c-.543.683-1.329.934-2.217.589a.53.53 0 0 0-.72.543 2.689 2.689 0 0 0 4.16-2.249c0-.36-.07-.688-.198-1.002a.53.53 0 0 0-.21-.035z",
    fill: "#ffab61",
    "data-original": "#ffab61"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.490f97b97ea28edfff996bceb363cad4.svg";
export { ForwardRef as ReactComponent };